<template>
  <div class="device-list">
    <ioc-table ref="deviceTableRef" :data="deviceData" :option="constData.deviceTable" :page="constData.page"
      @search-change="(val) => { handleSearchChange(val, 'device'); }"
      @search-reset="(val) => { handleSearchReset('device'); }" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
      <template slot="menuLeft">
        <div>
          <el-button type="primary" icon="el-icon-circle-plus-outline" size="small"
            @click="handleAddDevice">添加设备</el-button>
        </div>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item m5" effect="dark" content="移除" placement="top-start">
          <el-button type="text" class="el-icon-remove-outline" @click="handleDelDevice(scope.row)"></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
  </div>
</template>

<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { deviceTable } from "../config/deviceTable"
export default {
  name: 'deviceListByPerson',
  components: {},
  data() {
    return {
      constData: {
        page: {
          pageNum: 1,
          total: 0,
          pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
        },
        deviceTable: deviceTable(),
        deviceSearchForm: {}
      },
      deviceData: [],
      personnelGroupCode: '',
      personnelGroupName: ''
    }
  },
  methods: {
    // 条件搜索
    handleSearchChange(param, type) {
      this.constData.page.pageNum = 1;
      this.constData[`${type}SearchForm`] = Object.assign({}, param);
      this[`${type}GetList`]();
    },
    // 条件重置
    handleSearchReset(type) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = 10;
      this.constData[`${type}SearchForm`] = {};
      this[`${type}GetList`]();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.constData.page.pageNum = val;
      this.deviceGetList();
    },
    // 条数查询
    handleSizeChange(val) {
      this.constData.page.pageNum = 1;
      this.constData.page.pageSize = val;
      this.deviceGetList();
    },
    deviceGetList() {
      let params = {
        ...this.constData.page,
        ...this.constData.deviceSearchForm,
        personCode: this.personnelGroupCode,
        whether: 1 // 1 包含 0 不包含
      };
      this.$fetch(api.person.queryPersonDevice, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.deviceData = res.returnObj.list;
        this.constData.page.total = res.returnObj.total;
      });
    },
    deviceGetListParent(codeValue, nameValue) {
      if (codeValue == '') {
        this.$message({
          message: "请先选择人员",
          type: "warning",
          duration: 2000,
        });
        return
      }
      this.personnelGroupCode = codeValue
      this.personnelGroupName = nameValue
      this.$set(this.constData, 'page', {
        pageNum: 1,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      })
      let params = {
        ...this.constData.page,
        ...this.constData.deviceSearchForm,
        personCode: this.personnelGroupCode,
        whether: 1 // 1 包含 0 不包含
      };
      this.$fetch(api.person.queryPersonDevice, params).then((res) => {
        if (!res.success) {
          this.$$message.error(res.msgContent || "获取数据失败");
          return;
        }
        this.deviceData = res.returnObj.list;
        this.constData.page.total = res.returnObj.total;
      });
    },
    handleAddDevice() {
      this.$emit('openSelectDialog')
    },
    // 从群组移除人员
    handleDelDevice(row) {
      const params = {
        devices: [{
          deviceId: row.deviceId,
          thirdDeviceId: row.thirdDeviceId,
        }],
        personnel: {
          personnelCode: this.personnelGroupCode
        }
      };
      const deviceName = row.deviceName
      this.$confirm(`您确定要将 ${deviceName} 从 ${this.personnelGroupName} 移除吗?`, "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.person.delPersonDevice, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.deviceGetList(this.personnelGroupCode)
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.device-list {
  width: 100%;
  height: 100%;
}
</style>